/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import Breadcrumb from "../../../../Basis/Components/Breadcrumb";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nMandanten";

export default function MandantBelegeBreadcrumb() {
    const { t } = useTranslation();
    return (
        <Breadcrumb
            url="/mandantBelege"
            caption={t(translationKeys.mandantBelegeBreadcrumb.belege)}
        />
    );
}
